module.exports = __webpack_public_path__ + "static/img/standard.ba0f7d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/standard.png
// module id = 978
// module chunks = 41